module.exports = __webpack_public_path__ + "img/company.1aed4b10.png";